import React, { lazy, Suspense, useMemo } from 'react';
import { RouteComponentProps, Switch, Route } from 'react-router-dom';
import { Loader } from 'components';

interface ComponentProps {}

type Props = RouteComponentProps<any> & ComponentProps;

/**
 * Wraps NavPlugin component in a div, otherwise plugins end up squashed into a
 * small box.
 */
const NavPlugin = () => {
    const NavPlugin = useMemo(()=> lazy(() => import('views/Menu/NavPlugin')), []);
    return <div className="panel grow alt"><NavPlugin /></div>
}

const Tasks: React.FC<Props> = () => {
    const Task = useMemo(() => lazy(() => import('views/Tasks/Task')), []);
    const TaskMain = useMemo(() => lazy(() => import('views/Tasks/TaskMain')), []);
    const OutboundEmail = useMemo(() => lazy(() => import('views/Tasks/OutboundEmail')), []);
    return (
        <section className="row">
            <Suspense
                fallback={
                    <div className="lazy-loading">
                        <Loader />
                    </div>
                }
            >
                <Switch>
                    <Route path={`/task`} exact component={TaskMain} />
                    <Route path={`/task/outbound-email`} component={OutboundEmail} />
                    <Route path={`/task/:plugin`} component={NavPlugin} />
                    <Route path={`/tasks`} component={Task} />
                </Switch>
            </Suspense>
        </section>
    );
};

export default Tasks;
